export default {
  new_tag: 'Nieuw',
  groups: {
    dashboards: 'Dashboards',
    online_shop: 'Online Shop',
    home: 'Home',
    marketing: 'Marketing',
    reservations: 'Reserveringen',
    website: 'Website',
    orders_portal: 'Bestellingsportaal openen',
    roi: 'ROI',
    google_ads: 'Google Ads',
    mobile_app: 'Mobiele app',
    phone_answering: 'Telefoonbeantwoording',
    pricing: 'Prijzen',
    team: 'Team',
    data_deletion_requests: 'Verzoeken tot gegevensverwijdering',
    partner: 'Partner',
  },
  get_started: {
    title: 'Aan de slag',
  },
  onboarding: {
    title: 'Lancering',
  },
  new_restaurant: {
    title: 'Nieuw restaurant',
  },
  gift_cards: {
    title: 'Cadeaukaarten',
  },
  top_items: {
    title: 'Topproducten',
  },
  dashboards: {
    title: 'Dashboards',
    children: {
      general: 'Algemeen',
      restaurant_details: 'Restaurantgegevens',
      external_delivery: 'Externe bezorging',
      overview: 'Overzicht',
      orders: 'Bestellingen per bron',
      google: 'Google',
      customers: 'Klanten',
    },
  },
  customer_base: {
    title: 'Klantenbestand',
  },
  new_company: {
    title: 'Nieuw restaurant',
  },
  agent_ops_queue: {
    title: 'AI-suggesties',
  },
  external_delivery_support: {
    title: 'Ondersteuning externe bezorging',
  },
  payment_gateways: {
    title: 'Betaalgateways',
  },
  developers: {
    title: 'Ontwikkelaars',
  },
  feature_flags: {
    title: 'Feature flags',
  },
  platform_agent_log: {
    title: 'Amigo-log',
  },
  test_restaurants: {
    title: 'Testrestaurants',
  },
  partners: {
    title: 'Partners',
  },
  partner: {
    children: {
      account: 'Account',
      branding: 'Branding',
      payment_gateway: 'Betaalgateway',
      billing: 'Facturering',
      tax_currency: 'Belasting & Valuta',
      service_fee_calculator: 'Rekentool servicekosten',
      processing_fees: 'Transactiekosten',
    },
  },
  going_live: {
    title: 'Live gaan',
    children: {
      setup_package_fulfillments: 'Logsta-afhandelingen',
      polygraphy: 'Drukproducten',
    },
  },
  franchises: {
    title: 'Merken',
  },
  setup_package_fulfillments: {
    title: 'Pakketafhandelingen instellen',
  },
  website: {
    title: 'Website',
    children: {
      storefront: 'Storefront',
      studio: 'Studio (V1)',
      studio_v2: 'Studio (V2)',
    },
  },
  reservations: {
    title: 'Reservering',
    children: {
      overview: 'Overzicht',
      booking_availability: 'Beschikbaarheid',
      settings: 'Instellingen',
      general: 'Algemeen',
      storefront: 'Storefront',
    },
  },
  subscriptions: {
    title: 'Abonnementen',
    children: {
      subscriptions: 'Abonnementen',
      products: 'Producten',
    },
  },
  sales: {
    title: 'Verkoop',
    children: {
      orders: 'Bestellingen',
      receipts: 'Klantbonnen',
      external_deliveries: 'Externe bezorgingen',
    },
  },
  billing: {
    title: 'Rapporten',
    children: {
      monthly_statements: 'Maandoverzichten',
      payouts: 'Uitbetalingen',
      invoices: 'Facturen',
      subscription: 'Abonnement',
      sales_summary: 'Verkoopoverzicht',
      internal_invoice_items: 'Interne factuurposten',
      income_reports: 'Inkomstenrapporten',
      tax_reports: 'Belastingrapporten',
    },
  },
  master_menu: {
    title: 'Merksynchronisatie',
  },
  menu: {
    title: 'Menu',
    children: {
      master_overview: 'Merken',
      manage_menus: "Menu's beheren",
      modifiers: 'Opties',
      smart_pricing: 'Slimme prijzen',
      upsell_items: 'Upsell-items',
      sold_out_items: 'Uitverkochte items',
      import: 'Importeren',
      edit_history: 'Bewerkingsgeschiedenis',
    },
  },
  my_store: {
    title: 'Mijn info',
    children: {
      settings: 'Profiel',
      gallery: 'Galerij',
      business_information: 'Bedrijfsgegevens',
      documents: 'Mijn documenten',
      personal_information: 'Persoonlijke gegevens',
      bank_info: 'Bankgegevens',
      tax_info: 'Belastinggegevens',
      shipping_info: 'Verzendgegevens',
      google_profile: 'Google-profiel',
      seo: 'SEO',
      impressum: 'Impressum',
      imprint: 'Colofon',
      post_launch: 'Na de lancering',
      tax_currency: 'Belasting & Valuta',
    },
  },
  opening_hours: {
    title: 'Openingstijden & locatie',
    children: {
      opening_hours: 'Openingstijden',
      location: 'Locatie',
    },
  },
  order_settings: {
    title: 'Bestelinstellingen',
    children: {
      takeout: 'Bestelmethoden',
      missed_orders: 'Gemiste bestellingen',
      order_layout: 'Bestelindeling',
      payment_methods: 'Betaalmethoden',
      connect_paypal: 'PayPal koppelen',
      tips: 'Fooien',
      service_fee: 'Kosten',
      processing_fees: 'Transactiekosten',
      receipt: 'Bon',
      staff_credentials: 'Personeelscredentials',
      integrations: 'Integraties',
      terminal: 'Terminal',
      invoices: 'Facturen',
    },
  },
  mobile_app: {
    title: 'Mobiele app',
    children: {
      overview: 'Overzicht',
      updates: 'Updates',
      intro_screen: 'Introductiescherm',
    },
  },
  marketing: {
    children: {
      overview: 'Overzicht',
      followers: 'Volgers',
      email_messages: 'E-mailberichten',
      push_notifications: 'Pushmeldingen',
      promo_codes: 'Promocodes',
      offers: 'Aanbiedingen',
      google_business: 'Google Business',
      google_review_program: 'Google-reviewprogramma',
      loyalty_program: 'Loyaliteitsprogramma',
      polygraphy: 'Drukproducten',
      tracking_links: 'Trackinglinks',
      google_ads: 'Google Ads',
      website_analytics: 'Website-analyse',
      featured_posts: 'Posts mobiele app',
    },
  },
  loyalty_tablet: {
    title: 'Loyaliteitstablet',
    children: {
      dashboard: 'Dashboard',
      settings: 'Instellingen',
      credentials: 'Inloggegevens',
    },
  },
  contract: {
    title: 'Contract',
    children: {
      agreement: 'Overeenkomst',
      template: 'Sjabloon',
    },
  },
  team: {
    children: {
      managers: 'Beheerders',
      reports: 'Rapporten',
    },
  },
};
